// extracted by mini-css-extract-plugin
export default {"menuItem":"style_menuItem__QoFx4","menuItemIcon":"style_menuItemIcon__nIBcu","menuItemLabel":"style_menuItemLabel__kpk3c","light":"style_light__S22yf"};